'use strict';

module.exports = translateUserRoleFilter;

/*@ngInject*/
function translateUserRoleFilter($filter) {
    return function (role) {
        if (role === 'ADMIN') {
            return 'Admin';
        }
        if (role === 'USER') {
            return 'Kasutaja';
        }
        return role;
    };
}


/** WEBPACK FOOTER **
 ** ./app/shared/filters/translateUserRole.filter.js
 **/